module.exports = __webpack_public_path__ + "static/media/physician_technology.0b8e9e0e.jpg";